import { Button } from "@/components/_ui/button";
import { cn } from "@/lib/cn";
import { ArrowDownIcon, ArrowUpIcon } from "@radix-ui/react-icons";
import { Column } from "@tanstack/react-table";

interface DatatableColumnHeaderCellProps<TData, TValue> extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>;
  children: React.ReactNode;
}

export function DatatableColumnHeaderCell<TData, TValue>({
  column,
  children,
  className,
}: DatatableColumnHeaderCellProps<TData, TValue>) {
  const canSort = column.getCanSort();
  const isSorted = column.getIsSorted();
  return (
    <div className={cn("flex items-center gap-1 space-x-2 whitespace-nowrap", className)}>
      <>{children}</>
      {canSort && (
        <Button
          variant="ghost"
          size="icon"
          className="group h-6 w-6 hover:border data-[state=open]:bg-accent"
          onClick={() => {
            if (isSorted) {
              column.toggleSorting(isSorted === "asc");
            } else {
              column.toggleSorting(true);
            }
          }}
        >
          {isSorted === "desc" ? (
            <ArrowDownIcon className="h-3 w-3" />
          ) : isSorted === "asc" ? (
            <ArrowUpIcon className="h-3 w-3" />
          ) : (
            <ArrowUpIcon className="h-3 w-3 opacity-0 group-hover:opacity-100" />
          )}
        </Button>
      )}
    </div>
  );
}
